<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
input {
  font-size: 1rem;
}

html {
  -webkit-text-size-adjust: 100%;
  /* 防止 iOS 自动调整字体大小 */
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #fefefe;
  width: 100vw;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue